import "./Products.module.css";
import Header from "@/reusable_sections/Header";
import Hero from "./sections/Hero";
import HousingList from "./sections/HousingList";
import OnlineColorMatchingToolCta from "./sections/OnlineColorMatchingToolCta";
import Footer from "@/reusable_sections/Footer";
export default function ProductsPage() {
  return <div>
      <Header />
      <Hero />
      <HousingList />
      <OnlineColorMatchingToolCta />
      <Footer />
    </div>;
}